











import Vue from "vue";
import VideoRoomContainer from "@/components/Session/VideoRoomContainer.vue";
import { getGuestVideoToken } from "@/utils/guestJoin/guestJoinApi";
import { trackEvent } from "@/utils/analytics/analytics";
import { GUEST_JOIN_ROOM_CONNECTED } from "@/utils/analyticsEvents";

// Supplies VideoRoom.vue's injected tokenProvider (see the CR-300 seam in
// VideoRoom.vue) so the existing Twilio component can be reused unmodified for
// a guest, instead of forking it. Not-ready polls reuse VideoRoom's own
// status_message display ("Waiting for your clinician to join…") so no DOM
// changes are needed there for this state. The Twilio access_token comes only
// from /token — verify's own access_token is usually null (the clinician
// isn't in the room yet at that point), so it isn't relied on here. An
// unknown/expired guest_session_token is signalled by success: false alone,
// with no separate error field.
export default Vue.extend({
  name: "GuestVideoRoom",
  components: { VideoRoomContainer },
  props: {
    guestSessionToken: { type: String, required: true },
  },
  data() {
    return {
      hasConnected: false,
      hasEnded: false,
      booking: { appointmentType: "Video", appointmentId: "guest" },
    };
  },
  provide(): Record<string, unknown> {
    return {
      tokenProvider: this.tokenProvider,
    };
  },
  methods: {
    async tokenProvider(): Promise<{
      token?: string;
      roomReady: boolean;
      error?: string;
    }> {
      try {
        const response = await getGuestVideoToken(this.guestSessionToken);

        if (!response.success) {
          // Once the session has ended the backend closes it, so a poll that
          // was already in flight when the guest hung up resolves as a
          // failure. That isn't an expiry to recover from — sending them back
          // through /start would land on "this link isn't available", since
          // the invite is already consumed.
          if (!this.hasEnded) {
            this.$emit("session-expired");
          }
          return { roomReady: false, error: "Your session has expired." };
        }

        if (response.room_ready && response.access_token) {
          if (!this.hasConnected) {
            this.hasConnected = true;
            trackEvent(GUEST_JOIN_ROOM_CONNECTED);
          }
          return { token: response.access_token, roomReady: true };
        }

        return {
          roomReady: false,
          error: "Waiting for your clinician to join…",
        };
      } catch {
        return {
          roomReady: false,
          error: "Waiting for your clinician to join…",
        };
      }
    },
  },
});
